var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.052 32.596c-.008-.005-.017-.006-.025-.01l.002-.003-26.791-14.832a1.501 1.501 0 0 0-1.477.014L30.969 33.234a1.5 1.5 0 0 0-.75 1.299v11.431h3v-9.469l23.792 13.736V78.34L33.219 64.604v-6.762h-3v7.628a1.5 1.5 0 0 0 .75 1.299l26.792 15.468a1.499 1.499 0 0 0 1.5 0l26.791-15.468a1.5 1.5 0 0 0 .75-1.299V33.897a1.5 1.5 0 0 0-.75-1.299ZM58.527 20.785l23.728 13.137-6.136 3.542L52.578 24.22l5.949-3.435Zm-.016 26.845L35.27 34.213l9.305-5.373 23.541 13.244-9.606 5.546Zm25.291 16.972L60.011 78.338V50.229l9.047-5.223V59.27l7.999-4.622V40.387l6.745-3.894v28.109Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.051 60.864v5.892l4.272 2.357v-5.892l-4.272-2.357zm6.471 3.535v5.893l4.272 2.357v-5.893l-4.272-2.357zm-37.653-11.21h22.312a1.5 1.5 0 1 0 0-3H11.869l7.311-7.538a1.5 1.5 0 0 0-2.153-2.088L7.248 50.645a1.5 1.5 0 0 0 0 2.088l9.779 10.082a1.497 1.497 0 0 0 2.121.033 1.5 1.5 0 0 0 .032-2.121l-7.311-7.538Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageReturn);
export default __webpack_public_path__ + "static/media/package-return.d33260d8ac5e6e5a729058db73734b04.svg";
export { ForwardRef as ReactComponent };